import { selectTitleWithDescriptionNode } from '@newStore/documentUI/transformContent/genericSelectors';
import { type ExtendedRootNodeConfig, NodeType } from '@nodeTypeConfig/configTypes';
import { proThemeTocTypes } from '@nodeTypeConfig/helpers/buildingBlocks/proThemeTocTypes';
import { proAliasesComponent } from '@nodeTypeConfig/helpers/editComponents/proAliasesComponent';
import { proDocumentStandardComponents } from '@nodeTypeConfig/helpers/editComponents/proDocumentStandardComponents';
import { proThemeAudienceTab } from '@nodeTypeConfig/helpers/editComponents/proThemeAudienceTab';
import {
  asideWebBannerConfiguration,
  asideWebBasicConfiguration,
} from '@nodeTypeConfig/helpers/editComponents/webConfigComponents';
import { proDefaultBuildingBlocks } from '../../helpers/buildingBlocks/proDefaultBuildingBlocks';
import { proThemeDefaultValidationRules } from '../proGenericConfigProps';

const proThemeHome = {
  nodeSelector: selectTitleWithDescriptionNode,
  validationRules: proThemeDefaultValidationRules,
  information: {
    definiteArticle: true,
    single: 'PRO.-thema: Home',
    plural: "PRO.-thema's",
    icon: require('../../../../../img/icons/webpage.svg'),
  },
  extends: NodeType.WEBPAGE2,
  buildingBlocks: proDefaultBuildingBlocks,
  tocTypes: proThemeTocTypes,
  edit: [...proDocumentStandardComponents, proAliasesComponent],
  audienceTab: proThemeAudienceTab,
  webTab: [...asideWebBasicConfiguration, ...asideWebBannerConfiguration],
  addAccessRightsToAudienceTab: true,
};

// Extends WEBPAGE2 => When adding THEME_HOME_FULL WebConfig to a WEBPAGE2 it becomes a PRO_THEME_HOME_FULL
export const PRO_THEME_HOME_FULL: ExtendedRootNodeConfig = {
  ...proThemeHome,
  information: {
    ...proThemeHome.information,
    single: 'PRO.-thema: Home (titel, foto en korte omschrijving)',
  },
};

// Extends WEBPAGE2 => When adding THEME_HOME_PICTURE WebConfig to a WEBPAGE2 it becomes a PRO_THEME_HOME_PICTURE
export const PRO_THEME_HOME_PICTURE: ExtendedRootNodeConfig = {
  ...proThemeHome,
  information: {
    ...proThemeHome.information,
    single: 'PRO.-thema: Home (titel en foto)',
  },
};

// Extends WEBPAGE2 => When adding THEME_HOME_TEXT WebConfig to a WEBPAGE2 it becomes a PRO_THEME_HOME_TEXT
export const PRO_THEME_HOME_TEXT: ExtendedRootNodeConfig = {
  ...proThemeHome,
  information: {
    ...proThemeHome.information,
    single: 'PRO.-thema: Home (titel en korte omschrijving)',
  },
};
